import React from 'react';
import CatalogBrowser from './CatalogBrowser';

/**
 * Componente que gestiona la interfaz del escáner externo para desktop
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.manualInput - Indica si está en modo de entrada manual
 * @param {Function} props.setManualInput - Función para cambiar el modo de entrada manual
 * @param {boolean} props.catalogMode - Indica si está en modo catálogo
 * @param {Function} props.setCatalogMode - Función para cambiar el modo catálogo
 * @param {string} props.externalScanInput - Valor actual del input de escaneo externo
 * @param {Function} props.setExternalScanInput - Función para actualizar el valor del input
 * @param {Function} props.handleManualCodeSubmit - Manejador para enviar un código manual
 * @param {React.RefObject} props.inputRef - Referencia al input para enfoque automático
 * @param {string} props.searchTerm - Término de búsqueda para el catálogo
 * @param {Function} props.setSearchTerm - Actualiza el término de búsqueda
 * @param {Array} props.filteredEquiposCatalog - Lista de equipos filtrados para el catálogo
 * @param {Function} props.handleEquipoSelect - Función para manejar la selección de equipo
 * @param {Array} props.grupos - Lista de grupos de instalación
 * @param {Array} props.tipos - Lista de tipos de instalación
 * @param {Array} props.medidas - Lista de medidas de instalación
 * @returns {JSX.Element} Componente de escáner externo
 */
const ExternalScanner = ({
  manualInput,
  setManualInput,
  catalogMode,
  setCatalogMode,
  externalScanInput,
  setExternalScanInput,
  handleManualCodeSubmit,
  inputRef,
  searchTerm,
  setSearchTerm,
  filteredEquiposCatalog,
  handleEquipoSelect,
  grupos,
  tipos,
  medidas,
}) => {
  return (
    <div className="external-scanner-container">
      <div className="external-scanner-header">
        <div className="scanner-mode-toggle">
          <button
            className={`scanner-mode-btn ${!manualInput && !catalogMode ? "active" : ""}`}
            onClick={() => {
              setManualInput(false);
              setCatalogMode(false);
            }}
          >
            <i className="fa-solid fa-barcode"></i> Automático
          </button>
          <button
            className={`scanner-mode-btn ${manualInput && !catalogMode ? "active" : ""}`}
            onClick={() => {
              setManualInput(true);
              setCatalogMode(false);
            }}
          >
            <i className="fa-solid fa-keyboard"></i> Manual
          </button>
          <button
            className={`scanner-mode-btn ${catalogMode ? "active" : ""}`}
            onClick={() => {
              setManualInput(false);
              setCatalogMode(true);
            }}
          >
            <i className="fa-solid fa-book"></i> Catálogo
          </button>
        </div>
      </div>

      <div className="external-scanner-content">
        {!manualInput && !catalogMode ? (
          <div className="external-scanner-auto">
            <div className="external-scanner-display">
              <i className="fa-solid fa-barcode scanner-icon"></i>
              <div className="scanner-status-text">
                <p>Lector de códigos externo activado</p>
                <span className="scanner-instruction">
                  Escanee un código con su lector de códigos de barras USB
                </span>
              </div>
            </div>
            <div className="external-scanner-preview">
              {externalScanInput ? (
                <div className="external-scanner-code">
                  <span className="code-label">Último código escaneado:</span>
                  <span className="code-value">{externalScanInput}</span>
                </div>
              ) : (
                <div className="external-scanner-placeholder">
                  Esperando código...
                </div>
              )}
            </div>
          </div>
        ) : catalogMode ? (
          <CatalogBrowser
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            filteredEquiposCatalog={filteredEquiposCatalog}
            handleEquipoSelect={handleEquipoSelect}
            grupos={grupos}
            tipos={tipos}
            medidas={medidas}
          />
        ) : (
          <form className="external-scanner-manual" onSubmit={handleManualCodeSubmit}>
            <label htmlFor="manualCodeInput" className="scanner-label">
              Ingrese el código manualmente:
            </label>
            <div className="manual-input-container">
              <input
                id="manualCodeInput"
                type="text"
                className="scanner-input"
                placeholder="Formato: idEquipo_idGrupo_idTipo_idMedida"
                value={externalScanInput}
                onChange={(e) => setExternalScanInput(e.target.value)}
                ref={inputRef}
                autoFocus
              />
              <button type="submit" className="scanner-input-button">
                <i className="fa-solid fa-plus"></i> Añadir
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default React.memo(ExternalScanner);